import { ChevronsUpDown } from 'lucide-react'
import { cn } from '@/lib/utils/helpers'
import styles from '@/features/invitee/styles/invitesParity.module.css'
import configSortStyles from '@/components/listing/propertySortHeaderButton.module.css'
import type { CronMonitorSortColumnHeaderProps } from '../types'

function SortIcon({
  field,
  orderBy,
  sortBy,
}: {
  field: string
  orderBy?: string
  sortBy?: 'asc' | 'desc' | string
}) {
  const isActive = orderBy === field
  return (
    <span
      aria-hidden="true"
      className={cn(styles.sortIcon, isActive && styles.sortIconActive)}
    >
      {isActive ? (sortBy === 'asc' ? '▲' : '▼') : <ChevronsUpDown className="h-3 w-3" />}
    </span>
  )
}

/** Sortable column header — matches User/Product table sort pattern. */
export function CronMonitorSortColumnHeader({
  field,
  orderBy,
  sortBy,
  onSort,
  children,
  className = '',
  align = 'start',
  disabled = false,
}: CronMonitorSortColumnHeaderProps) {
  const handleSort = () => {
    if (disabled) return
    onSort(field)
  }

  return (
    <th
      data-testid={`cron-monitor-sort-${field}`}
      scope="col"
      className={cn(
        'select-none px-4 py-3 font-semibold',
        disabled ? 'pointer-events-none cursor-default' : 'cursor-pointer',
        align === 'center' ? '!text-center' : '!text-left',
        className,
      )}
      onClick={handleSort}
    >
      <button
        type="button"
        disabled={disabled}
        className={cn(
          styles.sortHeaderButton,
          configSortStyles.propertySortHeaderButton,
          'w-full',
          align === 'center' ? 'justify-center' : 'justify-start',
        )}
        onClick={(event) => {
          event.stopPropagation()
          handleSort()
        }}
      >
        <span className={styles.sortHeaderLabel}>{children}</span>
        <SortIcon field={field} orderBy={orderBy} sortBy={sortBy} />
      </button>
    </th>
  )
}
